function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import React, { Fragment } from 'react';
import { getAuthorBadges, getProfilePath } from '@finect/front-core/Profiles';
import { withTheme } from 'styled-components';
import { AdviserBadge } from '../AdviserBadge';
import { Icon } from '../Icon';
import { CardInfo, CardText, CardTitle, CardSubTitle, Tagline } from './partials';
var ProfileInfo = function ProfileInfo(_ref) {
  var entity = _ref.entity,
    theme = _ref.theme;
  var name = entity.name,
    icon = entity.icon,
    company = entity.company,
    tagline = entity.tagline,
    verified = entity.verified,
    aditionalIcon = entity.aditionalIcon,
    _entity$features = entity.features,
    features = _entity$features === void 0 ? [] : _entity$features,
    subtype = entity.subtype;
  var baseURL = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com');
  var entityPath = getProfilePath(theme, entity);
  var entityURL = entityPath.url;
  var upperName = "".concat(name.charAt(0).toUpperCase()).concat(name.slice(1));
  var badges = getAuthorBadges(entity);
  var subtitle;
  if (company) {
    var companyPath = getProfilePath(theme, company);
    var companyHasBlog = company.features && company.features.blog;
    subtitle = React.createElement(CardSubTitle, null, companyHasBlog ? React.createElement("a", {
      href: companyPath.url,
      title: "Ver perfil de ".concat(company.name)
    }, company.name) : company.name);
  }
  if (aditionalIcon) {
    subtitle = React.createElement(CardSubTitle, null, React.createElement("a", {
      href: "".concat(baseURL).concat(aditionalIcon.url),
      title: "Certificaci\xF3n ".concat(aditionalIcon.name)
    }, "Certificaci\xF3n ", aditionalIcon.name));
  }
  var linkProps = subtype === 'user' ? features.includes('profile') ? {
    href: entityURL,
    withLink: true
  } : {} : {
    href: entityURL,
    withLink: true
  };
  var iconProps = subtype === 'user' ? features.includes('profile') ? {
    url: entityURL
  } : {} : {
    url: entityURL
  };
  return React.createElement(CardInfo, null, React.createElement(Icon, _extends({
    type: entity.subtype,
    size: 3,
    alt: upperName,
    image: icon ? icon.includes('image') ? icon : "/image/".concat(icon) : null,
    margin: "0 18px 0 0",
    aditionalIcon: aditionalIcon,
    verified: verified,
    withBorder: entity.subtype === 'company'
  }, iconProps)), React.createElement(CardText, {
    centered: !tagline
  }, React.createElement(CardTitle, linkProps, upperName, badges.map(function (badge, key) {
    return React.createElement(Fragment, {
      key: key
    }, ' ', React.createElement(AdviserBadge, {
      title: badge
    }));
  })), subtitle, tagline ? React.createElement(Tagline, {
    extraMargin: Boolean(subtitle)
  }, tagline.length > 90 ? "".concat(tagline.slice(0, 87), "...") : tagline) : null));
};
export default React.memo(withTheme(ProfileInfo));